__turbopack_context__.v({
  "Survey": "fozhtq_Survey",
  "Survey--Collapsed": "fozhtq_Survey--Collapsed",
  "Survey--Expanded": "fozhtq_Survey--Expanded",
  "Survey__CloseButton": "fozhtq_Survey__CloseButton",
  "Survey__CollapsedButton": "fozhtq_Survey__CollapsedButton",
  "Survey__Content": "fozhtq_Survey__Content",
  "Survey__Header": "fozhtq_Survey__Header",
  "Survey__HeaderStatus": "fozhtq_Survey__HeaderStatus",
  "Survey__HeaderTitle": "fozhtq_Survey__HeaderTitle",
  "Survey__Nav": "fozhtq_Survey__Nav",
  "Survey__NavLeft": "fozhtq_Survey__NavLeft",
  "Survey__Steps": "fozhtq_Survey__Steps",
  "Survey__ThankYouStep": "fozhtq_Survey__ThankYouStep",
  "Survey__ThankYouStepText": "fozhtq_Survey__ThankYouStepText",
});
